import { system } from 'styled-system';

export const textTransform = system({
  textTransform: {
    property: 'textTransform',
  },
});
